export default {"src":"/_next/static/media/ico8.2c31f62f.svg","height":24,"width":28,"blurWidth":0,"blurHeight":0};